/*!
 * Copyright © 2020-2025. Verizon Connect Ireland Limited. All rights reserved.
 */

import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-success-banner',
  templateUrl: './success-banner.component.html',
  styleUrls: ['./success-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SuccessBannerComponent {
  @Input() successMessage: string | null = null;

  constructor() {}
}
